function InstructorRequestTimeOffController(
  UserService,
  $stateParams,
  $state,
  UsersModel,
) {
  const vm = this;
  vm.date = new Date();
  vm.currentUser = UserService.getCurrentUser();
  vm.requestType = {};

  vm.toggleRequest = toggleRequestType;

  init();

  function init() {
    UsersModel.getInstructorByID($stateParams.instructorId).then((response) => {
      vm.instructor = response;
    });
  }

  function toggleRequestType(type) {
    if (type === "dayOff") {
      vm.requestType.moreThanDay = false;
      $state.go("drivecoach.admin.instructors.view.timeoffrequests.create.day");
    }
    if (type === "moreThanDay") {
      vm.requestType.dayOff = false;
      $state.go(
        "drivecoach.admin.instructors.view.timeoffrequests.create.range",
      );
    }
  }
}
InstructorRequestTimeOffController.$inject = [
  "UserService",
  "$stateParams",
  "$state",
  "UsersModel",
];
export default InstructorRequestTimeOffController;
